import _ from 'lodash';
import BigNumber from 'bignumber.js';
import utils from '../../common/utils';
import {
  FETCH_TRANS_ERROR_FILTER_FAILED,
  FETCH_TRANS_ERROR_FILTER_SUCCEED,
  FETCH_TRANS_ERROR_SUCCEED,
  FETCH_TRANS_HISTORY_SUCCEED,
  FETCH_USER_TRANS_HISTORY_SUCCEED,
  FETCH_WITHDRAWAL_HISTORY_SUCCEED,
  SEARCH_TRANS_ERROR_FAILED,
  SEARCH_TRANS_ERROR_SUCCEED,
  VERIFY_TRANSACTION_SUCCEED,
  DELETE_TRANSACTION_SUCCEED,
  FETCH_VERIFY_HISTORY_SUCCEED,
} from '../actions/transactions/action_types';

export default (
  state = {
    trans: [],
    limit24h: 0,
    verify: {},
    txErrors: [],
    verifyHistories: [],
  }, action,
) => {
  switch (action.type) {
    // fetch order history
    case FETCH_TRANS_HISTORY_SUCCEED:
      _.forEach(action.data, (trans) => {
        trans.key = trans.id;
        trans.created_at = utils.formatTimeFromUnix(trans.created_at, 'DD/MM/YYYY HH:mm');
        trans.total = new BigNumber(trans.fee).plus(trans.amount).toFormat(8);
        trans.amount = utils.formatCurrency(trans.amount);
        trans.fee = utils.formatCurrency(trans.fee);
        trans.status = utils.parseTranStatus(trans.status);
      });

      return {
        ...state,
        trans: action.data,
      };
    case FETCH_TRANS_ERROR_SUCCEED:

      return {
        ...state,
        txErrors: action.data,
      };
    case FETCH_TRANS_ERROR_FILTER_SUCCEED:

      return {
        ...state,
        txErrors: action.data,
      };
    case FETCH_TRANS_ERROR_FILTER_FAILED:

      return {
        ...state,
        txErrors: [],
      };
    case SEARCH_TRANS_ERROR_SUCCEED:
      return {
        ...state,
        txErrors: action.data,
      };
    case SEARCH_TRANS_ERROR_FAILED:
      return {
        ...state,
        txErrors: [],
      };
    case FETCH_USER_TRANS_HISTORY_SUCCEED:
      _.forEach(action.data, (trans) => {
        trans.key = trans.id;
        trans.created_at = utils.formatTimeFromUnix(trans.created_at, 'DD/MM/YYYY HH:mm');
        trans.total = new BigNumber(trans.fee).plus(trans.amount).toFormat(8);
        trans.amount = utils.formatCurrency(trans.amount);
        trans.fee = utils.formatCurrency(trans.fee);
        trans.status = utils.parseTranStatus(trans.status);
      });

      return {
        ...state,
        trans: action.data,
      };
    case FETCH_WITHDRAWAL_HISTORY_SUCCEED:
      _.forEach(action.data, (trans) => {
        trans.key = trans.id;
      });
      return {
        ...state,
        trans: action.data,
        totalCount: action.totalCount,
      };
    case VERIFY_TRANSACTION_SUCCEED:
      return {
        ...state,
        verify: action.data,
      };
    case DELETE_TRANSACTION_SUCCEED:
      return {
        ...state,
      };
    case FETCH_VERIFY_HISTORY_SUCCEED:
      return {
        ...state,
        verifyHistories: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
